import { Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthProvider";
import { RequireAuth } from "./auth/RequireAuth";
import { StepUpProvider } from "./auth/StepUpProvider";
import type { RuntimeConfig } from "./config";
import { AppLayout } from "./layouts/AppLayout";
import { CallbackPage } from "./pages/CallbackPage";
import { HomePage } from "./pages/HomePage";
import { LoginPage } from "./pages/LoginPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { PrimitivesPage } from "./pages/PrimitivesPage";
import { ReleaseNotesPage } from "./pages/ReleaseNotesPage";
import { SecurityPage } from "./pages/account/SecurityPage";
import { AuditTrailPage } from "./pages/program/AuditTrailPage";

export function App({ config }: { config: RuntimeConfig }) {
  return (
    <AuthProvider config={config}>
      <StepUpProvider>
        <Routes>
          <Route element={<AppLayout config={config} />}>
            <Route index element={<HomePage />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="auth/callback" element={<CallbackPage />} />
            <Route
              path="account/security"
              element={
                <RequireAuth>
                  <SecurityPage />
                </RequireAuth>
              }
            />
            <Route
              path="program/audit"
              element={
                <RequireAuth>
                  <AuditTrailPage />
                </RequireAuth>
              }
            />
            <Route path="docs/release-notes" element={<ReleaseNotesPage config={config} />} />
            {config.envName !== "prod" && <Route path="primitives" element={<PrimitivesPage />} />}
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </StepUpProvider>
    </AuthProvider>
  );
}
